/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Err_Fee_InvalidInputs */

const vi_sales_return_err_fee_invalid = /** @type {(inputs: Sales_Return_Err_Fee_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phí trả hàng phải là số không âm`)
};

/**

* @param {Sales_Return_Err_Fee_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_fee_invalid = /** @type {((inputs?: Sales_Return_Err_Fee_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Fee_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_fee_invalid(inputs)
});